module.exports = __webpack_public_path__ + "static/media/62.93facc79.jpg";